export default __webpack_public_path__ + "files/BBM6.pdf";